import { SHFilterOption, SHStack } from "@components/design-systems";

import {
  RateCardSharedStatus,
  RateCardStatus,
} from "@models/rate-card/entities/rateCard";
import { FeatureTemplateStatus } from "@models/feature-template/enums/status";
import { PlatformAnalysisFilter } from "@models/platform-analysis/entities/steps/feature";
import { FeesDisplayStyle } from "@models/platform-analysis/enums/fee/displayStyle";
import { FeeHeatmapMode } from "@models/platform-analysis/enums/fee/heatmapMode";
import { FeeMissingInvestmentsOption } from "@models/platform-analysis/enums/fee/missingInvestments";
import { AnalysisStatus } from "@models/platform-analysis/enums/status";
import { FeeInvestmentMenuOption } from "@models/platform-analysis/enums/fee/investmentMenu";
import { ToggleButtonOptions } from "@components/design-systems/sh-toggle-button-options/model";
import { FeeCalculatorPortfolioLevel } from "@models/platform-analysis/enums/fee/portfolioLevel";
import { AnalysisStep } from "@models/platform-analysis/enums/step";
import { FeesDisplayMode } from "@models/platform-analysis/enums/fee/displayMode";
import { FeesPerformanceScope } from "@models/platform-analysis/enums/fee/feesPerformanceScope";
import { PortfolioCompositionViewMode } from "@models/platform-analysis/enums/portfolioCompositionViewMode";
import { ClientStatus } from "@models/reviews/enums/status";

export const PlatformAnalysisFilterOptions = [
  {
    label: "In progress",
    value: AnalysisStatus.InProgress,
  },
  {
    label: "Completed",
    value: AnalysisStatus.Completed,
  },
  {
    label: "Archived",
    value: AnalysisStatus.Archived,
  },
];

export const PlatformAnalysisProductsFilterOptions = [
  {
    label: "Common (Features available on each platform)",
    value: PlatformAnalysisFilter.Common,
  },
  {
    label: "Differentiators (Features not available on each platform)",
    value: PlatformAnalysisFilter.Differentiators,
  },
];

export const PlatformFeeAnalysisFilterOptions = [
  {
    label: "Not missing investment options",
    value: FeeMissingInvestmentsOption.NotMissing,
  },
  {
    label: "Missing investment options",
    value: FeeMissingInvestmentsOption.Missing,
  },
];

export const PlatformFeeAnalysisInvestmentMenuFilterOptions = [
  {
    label: "Full menu",
    value: FeeInvestmentMenuOption.FullMenu,
  },
  {
    label: "Limited menu",
    value: FeeInvestmentMenuOption.LimitedMenu,
  },
];

export const PlatformFeeAnalysisMissingInvestmentFilterOptions = [
  {
    label: "Hide those with missing investments",
    value: FeeMissingInvestmentsOption.NotMissing,
  },
];

export const RateCardFilterOptions: SHFilterOption[] = [
  {
    label: "Active",
    value: RateCardStatus.Active,
  },
  {
    label: "Archived",
    value: RateCardStatus.Archived,
  },
];

export const RateCardFilterYesNoOptions = [
  {
    label: "No",
    value: RateCardSharedStatus.No,
  },
  {
    label: "Internally",
    value: RateCardSharedStatus.Internally,
  },
  {
    label: "All practices",
    value: RateCardSharedStatus.AllPractices,
  },
];

export const FeeAnalysisFilterYesNoOptions = [
  {
    label: (
      <SHStack direction={"row"} spacing={"5px"}>
        <span>$</span>
        <span>Fees</span>
      </SHStack>
    ),
    value: FeesDisplayStyle.Dollar,
  },
  {
    label: (
      <SHStack direction={"row"} spacing={"5px"}>
        <span>%</span>
        <span>Fees</span>
      </SHStack>
    ),
    value: FeesDisplayStyle.Percentage,
  },
];

export const FeeAnalysisFilterMapOptions = [
  {
    label: "Detail",
    value: FeeHeatmapMode.Detail,
  },
  {
    label: "Projection",
    value: FeeHeatmapMode.Projection,
  },
];
export const FeatureTemplateFilterOptions = [
  {
    label: "Active",
    value: FeatureTemplateStatus.Active,
  },
  {
    label: "Archived",
    value: FeatureTemplateStatus.Archived,
  },
];
export const FeeReviewFilterMapOptions = [
  {
    label: "Detail",
    value: FeeHeatmapMode.Detail,
  },
  {
    label: "Projection",
    value: FeeHeatmapMode.Projection,
  },
];

export const FeeCalculatorPortfolioLevelOptions: ToggleButtonOptions[] = [
  { label: "No", value: FeeCalculatorPortfolioLevel.No },
  { label: "Family level", value: FeeCalculatorPortfolioLevel.Family },
  {
    label: "Account level",
    value: FeeCalculatorPortfolioLevel.Account,
    disabled: true,
    tooltip: "Account level coming soon",
  },
];

export const PlatformAnalysisHiddenFooterStepIndexes = [
  { selectedStep: AnalysisStep.BusinessMetric, selectedSubStepIndex: 1 },
  { selectedStep: AnalysisStep.Feature, selectedSubStepIndex: 1 },
];

export const FeesAnalysisTableViewModeOptions = [
  { label: "Summary", value: FeesDisplayMode.Summary },
  { label: "Detail", value: FeesDisplayMode.Detail },
];

export const FeesAnalysisTablePerformanceScopeOptions = [
  { label: "", value: FeesPerformanceScope.Including },
  { label: "", value: FeesPerformanceScope.Excluding },
];

export const PortfolioCompositionTableViewModeOptions = [
  { label: "", value: PortfolioCompositionViewMode.Included },
  { label: "", value: PortfolioCompositionViewMode.Excluded },
];

export const FamilyGroupFilterOptions = [
  {
    label: ClientStatus.Active,
    value: ClientStatus.Active,
  },
  {
    label: ClientStatus.Archived,
    value: ClientStatus.Archived,
  },
];
